window.complementaryProducts = {};

function syncComplementaryProducts() {
    window.complementaryProducts = {};
    document.querySelectorAll('.quick_add_item').forEach(function (card) {
        var cb = card.querySelector('.add_checkbox input');
        if (cb && cb.checked) {
            window.complementaryProducts[cb.value] = 1;
        }
    });
}

function toggleCheckBox(checkbox) {
    var card = checkbox.closest('.quick_add_item');
    if (!card) return;

    var variantId = checkbox.value;
    if (!variantId) return;

    if (checkbox.checked) {
        window.complementaryProducts[variantId] = 1;
        card.classList.add('is-added');
    } else {
        delete window.complementaryProducts[variantId];
        card.classList.remove('is-added');
    }
}

function resetComplementaryUI() {
    window.complementaryProducts = {};
    document.querySelectorAll('.quick_add_item').forEach(function (card) {
        card.classList.remove('is-added');
        var checkbox = card.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = false;
    });
}

function updateSizeVisibility(mainWrapper, productCard) {
    var variantsJSON = productCard.querySelector('.product-variants-json');
    if (!variantsJSON) return;

    var variants = JSON.parse(variantsJSON.textContent);
    var colorCol = mainWrapper.querySelector('.accessories_variant_col.color');
    var sizeCol = mainWrapper.querySelector('.accessories_variant_col.size');
    if (!colorCol || !sizeCol) return;

    var selectedColor = colorCol.querySelector('input:checked') ? colorCol.querySelector('input:checked').value : null;
    if (!selectedColor) return;

    var availableSizes = variants
        .filter(function (v) { return v.option1 === selectedColor; })
        .map(function (v) { return v.option2; });

    var firstVisible = null;

    sizeCol.querySelectorAll('input[type="radio"]').forEach(function (sizeInput) {
        var sizeLabel = sizeCol.querySelector('label[for="' + sizeInput.id + '"]');
        var exists = availableSizes.includes(sizeInput.value);

        sizeInput.style.display = exists ? '' : 'none';
        if (sizeLabel) sizeLabel.style.display = exists ? 'flex' : 'none';

        if (exists && !firstVisible) firstVisible = sizeInput;
        if (!exists && sizeInput.checked) sizeInput.checked = false;
    });

    // Auto-check first visible size if nothing is checked
    var anyChecked = sizeCol.querySelector('input[type="radio"]:checked');
    if (!anyChecked && firstVisible) {
        firstVisible.checked = true;
        var sizeSelectedText = sizeCol.querySelector('.selected_text');
        if (sizeSelectedText) sizeSelectedText.textContent = firstVisible.value;
    }
}

function initHideSizes() {
    document.querySelectorAll('.grid-product__options').forEach(function (mainWrapper) {
        var productCard = mainWrapper.closest('.grid__item');
        if (!productCard) return;

        var variantsJSON = productCard.querySelector('.product-variants-json');
        if (!variantsJSON) return;

        var variants = JSON.parse(variantsJSON.textContent);
        var colorCol = mainWrapper.querySelector('.accessories_variant_col.color');
        var sizeCol = mainWrapper.querySelector('.accessories_variant_col.size');
        if (!colorCol || !sizeCol) return;

        var selectedColor = colorCol.querySelector('input:checked') ? colorCol.querySelector('input:checked').value : null;
        if (!selectedColor) return;

        var availableSizes = variants
            .filter(function (v) { return v.option1 === selectedColor; })
            .map(function (v) { return v.option2; });

        sizeCol.querySelectorAll('input[type="radio"]').forEach(function (sizeInput) {
            var sizeLabel = sizeCol.querySelector('label[for="' + sizeInput.id + '"]');
            var exists = availableSizes.includes(sizeInput.value);
            sizeInput.style.display = exists ? '' : 'none';
            if (sizeLabel) sizeLabel.style.display = exists ? 'flex' : 'none';
        });
    });
}

function getOptionValue(el) {
    if (!el) return;

    const optionValue = el.value || '';
    const wrapper = el.closest('.accessories_variant_col');
    const mainWrapper = el.closest('.grid-product__options');
    const productCard = el.closest('.grid__item');
    const mainCheckbox = el.closest('.grid-product.quick_add_item')?.querySelector('.add_checkbox input');

    if (wrapper) {
        const selectedTextEl = wrapper.querySelector('.selected_text');
        if (selectedTextEl) selectedTextEl.textContent = optionValue;
    }

    if (productCard && mainWrapper) {
        updateSizeVisibility(mainWrapper, productCard);
    }

    let selectedValue = '';
    if (mainWrapper) {
        const checkedInputs = mainWrapper.querySelectorAll('input:checked');
        if (checkedInputs.length === 1) {
            selectedValue = checkedInputs[0].value;
        } else if (checkedInputs.length > 1) {
            selectedValue = Array.from(checkedInputs)
                .map(input => input.value)
                .join(' / ');
        }
    }

    // Match select option and update checkbox + price
    if (mainWrapper && selectedValue) {
        const select = mainWrapper.querySelector('select');
        if (select) {
            const option = Array.from(select.options).find(
                opt => opt.value === selectedValue || opt.text === selectedValue
            );
            if (option) {
                select.value = option.value;
                select.dispatchEvent(new Event('change'));

                if (mainCheckbox) mainCheckbox.value = option.value;

                syncComplementaryProducts();

                const priceSpan = productCard?.querySelector('.grid-product__price span:not([data-wpd-variant-price])');
                const newPrice = option.getAttribute('data-price');
                if (priceSpan && newPrice) priceSpan.textContent = newPrice;

                const originalPriceEl = productCard?.querySelector('.grid-product__price--original');
                const compareAt = option.getAttribute('data-compare-at-price');
                if (originalPriceEl) {
                    originalPriceEl.style.display = (compareAt && parseInt(compareAt) > 0) ? '' : 'none';
                }

            }
        }
    }

    // Update thumbnail image — runs independently of select matching
    if (productCard) {
        const variantsJSON = productCard.querySelector('.product-variants-json');
        if (variantsJSON) {
            try {
                const variants = JSON.parse(variantsJSON.textContent);
                const checkedByOption = {};
                if (mainWrapper) {
                    mainWrapper.querySelectorAll('.accessories_variant_col').forEach((col, i) => {
                        const checked = col.querySelector('input[type="radio"]:checked');
                        if (checked) checkedByOption[i + 1] = checked.value;
                    });
                }
                const matched = variants.find(v =>
                    Object.entries(checkedByOption).every(([pos, val]) => v['option' + pos] === val)
                );
                if (matched && matched.image) {
                    const img = productCard.querySelector('.thumbnail img');
                    if (img) {
                        img.src = matched.image;
                        img.removeAttribute('srcset');
                    }
                }
            } catch(e) {}
        }
    }
}

function syncThumbnailImages() {
    document.querySelectorAll('.grid__item').forEach(function(productCard) {
        var variantsJSON = productCard.querySelector('.product-variants-json');
        var mainWrapper = productCard.querySelector('.grid-product__options');
        if (!variantsJSON || !mainWrapper) return;

        try {
            var variants = JSON.parse(variantsJSON.textContent);
            var checkedByOption = {};
            mainWrapper.querySelectorAll('.accessories_variant_col').forEach(function(col, i) {
                var checked = col.querySelector('input[type="radio"]:checked');
                if (checked) checkedByOption[i + 1] = checked.value;
            });

            var matched = variants.find(function(v) {
                return Object.entries(checkedByOption).every(function(entry) {
                    return v['option' + entry[0]] === entry[1];
                });
            });

            if (matched && matched.image) {
                var img = productCard.querySelector('.thumbnail img');
                if (img) {
                    img.src = matched.image;
                    img.removeAttribute('srcset');
                }
            }
        } catch(e) {}
    });
}

document.addEventListener('DOMContentLoaded', function() {
    initHideSizes();
    syncThumbnailImages();

    document.querySelectorAll('product-recommendations').forEach(function(el) {
        new MutationObserver(function() {
            syncThumbnailImages();
            initHideSizes();
        }).observe(el, { childList: true, subtree: true });
    });
});

document.addEventListener('click', function (e) {
    var mainBtn = e.target.closest('.add-to-cart');
    if (!mainBtn) return;

    var selected = Object.keys(window.complementaryProducts);
    if (!selected.length) return;

    e.preventDefault();
    e.stopPropagation();

    var form = mainBtn.closest('form');
    if (!form) return;

    mainBtn.disabled = true;

    var formData = new FormData(form);
    var mainVariantId = formData.get('id');

    if (!mainVariantId) {
        mainBtn.disabled = false;
        return;
    }

    var payload = { items: [] };
    payload.items.push({ id: mainVariantId, quantity: 1 });

    selected.forEach(function (id) {
        payload.items.push({ id: id, quantity: 1 });
    });

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    })
        .then(function (res) { return res.json(); })
        .then(function (data) {
   
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: { product: data }
            }));
            mainBtn.disabled = false;
        })
        .catch(function () {
            mainBtn.disabled = false;
        });
});
